import React from 'react';
import FilterReport from './FilterReport';
const OrganizationTrainingReports = () => {
     return (
          <div className="survey-reports">
               <h2 className="survey-reports-title">Organization Training Reports</h2>
               <FilterReport />
          </div>
     );
};

export default OrganizationTrainingReports;
